var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createMuiTheme } from '@material-ui/core/styles';
import { light, dark } from '@material-ui/core/styles/createPalette';
/**
 * 「実技」という教科は国社数理英の5教科以外をすべて含むもの。
 * 実際は音楽や美術などがある。
 *
 * TODO すべて同じ色かもしれないが、ソースコード上は教科毎に分ける
 */
var practicalSkillsColor = {
    primary: '#007fa9',
    sedondary: '#ebfdff',
    tertiary: '#b6e1ee',
};
// TODO 正しいテーマ設定をVDと取り決める
export var defaultTheme = createMuiTheme({
    breakpoints: {
        values: {
            xs: 0,
            md: 1024,
            lg: 1366,
        },
    },
    shape: {
        borderRadius: 8,
        borderWidth: {
            normal: 2,
            thin: 1,
        },
    },
    typography: {
        fontSize: 18,
        fontFamily: '"MJS-GJShinMGoProN", "Helvetica Neue", "Noto Sans", "Arial", "Hiragino Kaku Gothic ProN", "meiryo", "Noto Sans CJK JP", sans-serif',
        heading: {
            fontSize: 24,
            lineHeight: '38px',
            fontWeight: 'initial',
        },
        title: {
            fontSize: 21,
            lineHeight: '29px',
            fontWeight: 'initial',
        },
        body1: {
            fontSize: 18,
            lineHeight: '26px',
            fontWeight: 'initial',
        },
        body2: {
            fontSize: 16,
            lineHeight: '24px',
            fontWeight: 'initial',
        },
        caption: {
            fontSize: 14,
            lineHeight: '22px',
            fontWeight: 'initial',
        },
        minimum: {
            fontSize: 12,
            lineHeight: '20px',
            fontWeight: 'initial',
        },
    },
    // filter: drop-shadowはiOS Safariで適用されないので、box-shadowを使う
    shadows: [
        'none',
        // 'drop-shadow(0 1px 4px rgba(0, 0, 0, 0.4))', // バー、カード
        '0 1px 4px 0 rgba(0, 0, 0, 0.4)',
        // 'drop-shadow(0 2px 16px rgba(0, 0, 0, 0.4))', // ダイアログ、セレクトメニュー、ポップアップ
        '0 4px 8px 6px rgba(0, 0, 0, 0.1)',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
    ],
    palette: {
        common: {
            black: '#4b4b4b',
            white: '#fff',
        },
        error: {
            main: '#f40000',
        },
        background: {
            default: '#e5e5e5',
        },
        primary: {
            main: '#2c6ef5',
            light: '#699bfc',
            dark: '#2d59b2',
            '50': '#e8f0ff',
            '100': '#bbcdf5 ',
            '200': '#8eb5fc',
            '300': '#699bfc',
            '500': '#2c6ef5',
            '600': '#3a73e5',
            '700': '#2d59b2',
        },
        action: {
            hover: 'rgba(75, 75, 75, 0.1)',
            active: 'rgba(75, 75, 75, 0.2)',
            hoverOpacity: 0.1,
            activatedOpacity: 0.2,
        },
        light: __assign(__assign({}, light), { text: {
                primary: '#4b4b4b',
                secondary: '#696969',
                hint: '#c3c3c3',
                disabled: '#c3c3c3',
            }, background: {
                default: '#e5e5e5',
                paper: '#fff',
            }, action: __assign(__assign({}, light.action), { disabled: '#c3c3c3' }), divider: '#e5e5e5' }),
        dark: __assign(__assign({}, dark), { text: {
                primary: '#fff',
                secondary: '#e5e5e5',
                hint: '#c3c3c3',
                disabled: '#696969',
            }, background: {
                default: '#000',
                paper: '#4b4b4b',
            }, action: __assign(__assign({}, dark.action), { disabled: '#696969' }), divider: '#696969' }),
        apps: {
            note: '#0099FF',
            drill: '#FF5252',
            moral: '#09C309',
            keyboard: '#FFC71B',
            chart: '#FFC71B',
            block: '#FF5252',
            appdesigner: '#0099FF',
            customer: '#109EAE',
        },
        subjects: {
            japanese: {
                primary: '#cf3a3b',
                sedondary: '#fff6f6',
                tertiary: '#fccfd4',
            },
            math: {
                primary: '#2265ce',
                sedondary: '#f2f8ff',
                tertiary: '#bcdeff',
            },
            english: {
                primary: '#e87100',
                sedondary: '#fff9e6',
                tertiary: '#f7deb2',
            },
            science: {
                primary: '#007d51',
                sedondary: '#effef7',
                tertiary: '#bfe4d3',
            },
            society: {
                primary: '#7848af',
                sedondary: '#fcf5ff',
                tertiary: '#dfd3ee',
            },
            practicalSkills: practicalSkillsColor,
        },
    },
    props: { MuiButtonBase: { disableRipple: true } },
});
